/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useEffect } from "react";
import { When } from "react-if";
import { theme } from "@nordcloud/gnui";
import { ActionScope } from "~/generated/graphql";
import { useGetResources } from "~/hooks";
import { isEmpty } from "~/tools";
import { SelectedAction } from "../types";

export function ResourcesSummary({ action }: { action: SelectedAction }) {
  const { getResources, resources } = useGetResources();

  const resourcesNames = resources
    .filter((resource) => action?.resourceIds?.includes(resource.id))
    .map(({ name }) => name);

  useEffect(() => {
    getResources();
  }, [getResources]);

  return (
    <>
      {isEmpty(action?.resourceIds ?? []) &&
      action.scope !== ActionScope.Plan ? (
        <div css={{ color: theme.color.text.text03 }}>
          Resources not assigned
        </div>
      ) : (
        <div css={{ wordBreak: "break-word" }}>
          {resourcesNames?.map((name, index) => {
            return `${index ? "," : ""} ${name}`;
          })}
        </div>
      )}
      <When condition={action.scope === ActionScope.Plan}>
        <div css={{ color: theme.color.text.text03 }}>
          There are no individual resources for Plan based action scope
        </div>
      </When>
    </>
  );
}
